module.exports = "<p>\n  view-category works!\n</p>\n"